import RouteView from '@/router/RouteView.vue';
import Account from './index.vue';
import AccountBill from '../Bill/index.vue';
// import Detail from '../Bill/Detail.vue';
import Statistical from '../Bill/Statistical';
import StatisticalClass from '../Statistical/StatisticalClass.vue';
import BillStatistical from '../Statistical/index.vue';
import AccountPay from './Pay.vue';

export default [
  {
    path: '/account',
    name: 'Account',
    component: RouteView,
    redirect: '/account/list',
    meta: {
      title: '账户管理',
    },
    children: [
      {
        path: '/account/list',
        name: 'AccountList',
        component: Account,
        meta: {
          title: '账户信息',
        },
      },
      {
        path: '/account/pay',
        name: 'AccountPay',
        component: AccountPay,
        meta: {
          title: '充值',
        },
      },
      {
        path: '/account/bill/:id',
        name: 'AccountBill',
        component: AccountBill,
        meta: {
          title: '校区账单',
        },
      },
      {
        path: '/account/bill/statistical/:code/:id',
        name: 'BillStatistical',
        component: Statistical,
        meta: {
          title: '统计',
        },
      },
      {
        path: '/account/bill/statisticalclass/:id',
        name: 'StatisticalClass2',
        component: StatisticalClass,
        meta: {
          title: '上课统计',
        },
      },
      {
        path: '/account/bill/goldStatistical/:type',
        name: 'Statistical2',
        component: BillStatistical,
        meta: {
          title: '消费统计',
        },
      },
      // {
      //   path: '/account/bill/golddetail/:code',
      //   name: 'GoldDetail',
      //   component: Detail,
      //   meta: {
      //     title: '金币详单'
      //   },
      // },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/views/Account/index.js